export default {
	API_URL: 'https://api-rubert.infinitum-ti.com/api',
	OAPI_URL: 'https://api-rubert.infinitum-ti.com/oapi',
	//  API_URL: 'http://localhost:2391/api',
	//  OAPI_URL: 'http://localhost:2391/oapi',
}
